var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#B5C7F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 15C21.4146 15 21.5725 15.0654 21.6889 15.1818C21.8053 15.2982 21.8707 15.4561 21.8707 15.6207V20.3793H26.6293C26.7939 20.3793 26.9518 20.4447 27.0682 20.5611C27.1846 20.6775 27.25 20.8354 27.25 21C27.25 21.1646 27.1846 21.3225 27.0682 21.4389C26.9518 21.5553 26.7939 21.6207 26.6293 21.6207H21.8707V26.3793C21.8707 26.5439 21.8053 26.7018 21.6889 26.8182C21.5725 26.9346 21.4146 27 21.25 27C21.0854 27 20.9275 26.9346 20.8111 26.8182C20.6947 26.7018 20.6293 26.5439 20.6293 26.3793V21.6207H15.8707C15.7061 21.6207 15.5482 21.5553 15.4318 21.4389C15.3154 21.3225 15.25 21.1646 15.25 21C15.25 20.8354 15.3154 20.6775 15.4318 20.5611C15.5482 20.4447 15.7061 20.3793 15.8707 20.3793H20.6293V15.6207C20.6293 15.4561 20.6947 15.2982 20.8111 15.1818C20.9275 15.0654 21.0854 15 21.25 15Z",
    fill: "#081B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigAdd);
export default __webpack_public_path__ + "static/media/bigAdd.6a95765f7c18013f2636455b4940ad24.svg";
export { ForwardRef as ReactComponent };